<template>
  <button class="fareCapsule" @click="$emit('onFareSelected')">
    <span class="fareCapsule__fareName">{{ ffamFareItem.name }}</span>
    <div class="fareCapsule__farePrice">
      <span class="fareCapsule__price">{{
        fareItemPrice | amountFormatPipe
      }}</span>
      <span class="fareCapsule__currency">{{
        ffamFareItem.fare_information?.currency_reference_id
      }}</span>
    </div>
  </button>
</template>
<script>
import filters from '../../helpers/filters'
export default {
  name: 'UpsellingFareCapsule',
  inject: ['configurations'],
  mixins: [filters],
  props: {
    ffamFareItem: {
      type: Object,
      required: true,
    },
    tripSegment: {
      type: Number,
      required: true,
    },
    minimumPriceToCompare: {
      type: Object,
      required: false,
    },
  },
  computed: {
    displayFullPrices: function () {
      return (
        !this.minimumPriceToCompare || this.configurations.displayFullPrices
      )
    },
    fareItemPrice: function () {
      const amount =
        this.ffamFareItem.fare_information?.trip_segment_prices[
          this.tripSegment
        ].total
      if (this.displayFullPrices) return amount
      return amount - this.minimumPriceToCompare.total
    },
  },
}
</script>

<style lang="sass" scoped>
.fareCapsule
  display: flex
  justify-content: space-between
  padding: .75rem
  border-radius: .5rem
  width: 100%
  background-color: var(--color-primary)
  color: var(--color-onPrimary)
  border: none
  &.--active
    background-color: var(--color-onPrimary)
    color: var(--color-primary)
    border: 1px solid
.fareCapsule__farePrice
  display: flex
  gap: .25rem
  align-items: center

.fareCapsule__price, .fareCapsule__name
  font-size: 1.125rem
  font-weight: 700
  line-height: 1.625rem
.fareCapsule__currency
  text-transform: uppercase
  font-size: var(--font-size-sbase)
</style>
